import { gql } from '@apollo/client';

export const CreateEvent = gql`
mutation CreateEvent($name: String!, $location: String!, $startAt: DateTime!, $registerStartAt: DateTime!, $registerEndAt: DateTime!, $endAt: DateTime!, $categories: [String]!, $media: String, $infoMedia: String, $level: String, $type: String) {
  createEvent(name: $name, location: $location, startAt: $startAt, registerStartAt: $registerStartAt, registerEndAt: $registerEndAt, endAt: $endAt, categories: $categories, media: $media, infoMedia: $infoMedia, level: $level, type: $type) {
    id
  }
}`;

export const UpdateEvent = gql`
mutation UpdateEvent($id: Int!, $name: String, $location: String, $startAt: DateTime, $registerStartAt: DateTime, $registerEndAt: DateTime, $endAt: DateTime, $media: String, $infoMedia: String, $level: String, $type: String, $status: String, $categories: [String]) {
  updateEvent(id: $id, name: $name, location: $location, startAt: $startAt, registerStartAt: $registerStartAt, registerEndAt: $registerEndAt, endAt: $endAt, media: $media, infoMedia: $infoMedia, level: $level, type: $type, status: $status, categories: $categories) {
    id
  }
}
`;

export const ConvertDocumentToImage = gql`
mutation ConvertDocumentToImage($base64: String!) {
  convertDocumentToImage(base64: $base64)
}
`;

export const DeleteEvent = gql`
mutation DeleteEvent($deleteEventId: Int!) {
    deleteEvent(id: $deleteEventId) {
      message
      status
    }
  }
`;

export const JoinEvent = gql`
mutation JoinEvent($joinEventId: Int!) {
  joinEvent(id: $joinEventId) {
    status
    message
  }
}
`;

export const ConfirmEvent = gql`
mutation ConfirmPlayerOnEvent($playerId: Int!, $eventId: Int!, $isConfirmed: Boolean!) {
  confirmPlayerOnEvent(playerId: $playerId, eventId: $eventId, isConfirmed: $isConfirmed) {
    status
    message
  }
}
`;

export const AddPlayerToEventAsAdmin = gql`
mutation AddPlayerToEventAsAdmin($eventId: Int!, $userId: Int!) {
  addPlayerToEventAsAdmin(eventId: $eventId, userId: $userId) {
    status
    message
  }
}
`;

export const LeaveEvent = gql`
mutation LeaveEvent($eventId: Int!, $userId: Int) {
  leaveEvent(eventId: $eventId, userId: $userId) {
    status
    message
  }
}
`;

export const ValidateEventDeposit = gql`
mutation ValidateEventDeposit($playerId: Int!, $eventId: Int!) {
  validateEventDeposit(playerId: $playerId, eventId: $eventId) {
    playerId
    eventId
    depositProvided
  }
}
`;

export const RevokeEventDeposit = gql`
mutation RevokeEventDeposit($playerId: Int!, $eventId: Int!) {
  revokeEventDeposit(playerId: $playerId, eventId: $eventId) {
    playerId
    eventId
    depositProvided
  }
}
`;
